"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_actions_1 = __importDefault(require("../../redux/scenario/scenario.actions"));

var set_action_url_button_component_1 = __importDefault(require("./set-action-url-button.component"));

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var SetActionUrlButtonContainer = function SetActionUrlButtonContainer(_ref) {
  var nodeId = _ref.nodeId,
      optionIndex = _ref.optionIndex;
  var dispatch = react_redux_1.useDispatch();
  var option = react_redux_1.useSelector(scenario_selectors_1.getSelectOption(nodeId, optionIndex));
  if (!option) throw new Error("Failed to select option @SetActionUrlButtonContainer !!! ".concat(JSON.stringify({
    nodeId: nodeId,
    optionIndex: optionIndex
  })));
  var urlVariables = react_redux_1.useSelector(scenario_selectors_1.selectUrlVariables);
  var urlVariable = urlVariables.find(function (variable) {
    return option.actionUrl === "${".concat(variable.key, "}");
  });
  if (!urlVariable) throw new Error("Failed to find urlVariable @SetActionUrlButtonContainer!!! ".concat(JSON.stringify({
    nodeId: nodeId,
    optionIndex: optionIndex,
    option: option
  })));
  return react_1.default.createElement(set_action_url_button_component_1.default, {
    urlVariable: urlVariable,
    setActionUrl: function setActionUrl(url) {
      dispatch(scenario_actions_1.default.setActionUrl({
        nodeId: nodeId,
        optionIndex: optionIndex,
        url: url
      }));
    },
    removeActionUrl: function removeActionUrl() {
      dispatch(scenario_actions_1.default.removeActionUrl({
        nodeId: nodeId,
        optionIndex: optionIndex
      }));
    }
  });
};

exports.default = SetActionUrlButtonContainer;